import React from "react";
import { BannerContents } from "../../components/shared/layout";
import { Row, Col } from 'react-bootstrap';
import { Button } from '../../components/shared/actions';
import imagensHome from '@asserts/images/home';

export const BannerCampanha = () => {
  return (
<BannerContents.Banner
backgroundImage={imagensHome.bannerCampanhaViver}
className="text-white"
left
>
<Row className="ml-5">
  <Col xs={12} className="d-flex align-items-stretch">
    <h3 className="d-md-inline-block banner-campanha-viver">
      SEGUROS DE VIDA <br />E PREVIDÊNCIA DA CAIXA.
    </h3>
  </Col>
  <Col xs={12} className="d-flex align-items-stretch">
    <p className="text-body-md titulo-campanha-viver">é por você</p>
  </Col>
  <Col xs={12} className="d-flex align-items-stretch">
    <p className="text-body-md texto-campanha-viver">
      e por quem você ama.
    </p>
  </Col>
  <Col xs={12} className="d-flex button-campanha-viver">
    <p className="text-body-md">Assita ao vídeo na íntegra</p>
  </Col>
  <Col xs={12} className="d-flex">
    <Button
      className="text-center cvp-action-comprar"
      blank
      secondary
      href="https://static.caixavidaeprevidencia.com.br/AreaAberta/Campanhas/Videos/Campanha-Viver.mp4"
      style={{ fontWeight: 'bold' }}
    >
      Clique aqui
    </Button>
  </Col>
</Row>
</BannerContents.Banner>
  );
}
export default BannerCampanha;